import { useNavigate } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

import HoverNavButton from "../components/HoverNavButton";

function About(){
    const navigate = useNavigate();
    return(
        <div>
            <NavBar/>
            <main>
                <div>
                    <h1 className={'about-us'}>About Us</h1>
                    
                    <div className='centered'>
                        <img src="/img/osseo-full-logo-white.jpeg" alt="Osseo Logo" className='about-img'/>
                        <p><span style={{fontWeight: 'bold'}}>Osseo Dental</span> is a boutique style crown and bridge studio.</p>
                        <p>We specialize in custom restorations that take the extra knowledge and expertise that only comes from a passion for detail.</p>
                        <p>From single molar restorations to anterior and full mouth reconstruction. Our restorations, crafted with passion become works of art.</p>
                    </div>
                </div>
                <div className='about-zeiss'>
                    <img src='/img/zeiss.png' style={{width: '7.5rem'}} className='zeiss-logo' onClick={() => window.open('https://www.zeiss.com/photonics-and-optics/en/home.html')}/>
                    <p className='about-zeiss-text'><span>All restorations manufactured at Osseo are fit adjusted and inspected using Zeiss Optic microscopes, producing the sharpest, most precise margins in the industry.</span></p>
                </div>
                <div style={{paddingTop: '5rem'}}>
                    <div className='about'>
                        <div className='about-grid'>
                            <div className='team-card'>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <img src="/img/dave.jpeg" alt="Dave Guenette" style={{borderRadius: '50px'}}/>
                                </div>
                                <div>
                                    <h3 style={{fontSize: '2rem'}}>Dave Guenette</h3>
                                    <p style={{marginTop: '-20px', marginBottom: '3rem', fontSize: '1.25rem'}}>Owner</p>
                                    
                                    <p>David received his Dental Technology Certificate from the Northern Alberta Institute of Technology (NAIT) in 1995. Specializing in Crown, Bridge and Implant Restorations for over 30 years in the Edmonton area.</p>
                                    <p>He has helped propel his lab to the forefront of digital design, mill and print technology while still being able to solve unique problems from years of "old school" knowledge.</p>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
            </main>
            <Footer/>
        </div>
    )
        
}
export default About;